import { Track, TrackType } from '@prisma/client'
import { useForm, SubmitHandler } from 'react-hook-form'
import { updateTrack, deleteTrack } from '@src/lib/apiClient'
import toast from 'react-hot-toast'
import { AudioOn, AudioDescription } from '@src/components/icons'

type TrackEditorProps = {
  track: Track
  onDeleteTrackSuccess: (id: number) => void
}

export function TrackEditor({ track, onDeleteTrackSuccess }: TrackEditorProps) {
  const { register, handleSubmit, watch } = useForm<Track>({ defaultValues: track })
  const watchTrackType = watch('trackType')

  const onSubmit: SubmitHandler<Track> = async (data) => {
    const res = await updateTrack(data)
    if (res.error) {
      toast.error(res.error.message)
    }
  }

  const onDeleteTrack = async () => {
    if (!window.confirm('Are you sure you want delete this audio track?')) {
      return
    }
    const res = await deleteTrack(track.id)
    if (res.error) {
      toast.error(res.error.message)
    }
    toast.success('Track deleted.')
    onDeleteTrackSuccess(track.id)
  }

  return (
    <form onChange={handleSubmit(onSubmit)}>
      <div className="audio-track-editor">
        {watchTrackType === TrackType.AUDIO_DESCRIPTION ? <AudioDescription /> : <AudioOn />}
        <audio id={`audio-upload-${track.id}`} controls> {/* eslint-disable-line */}
          <source src={track.audioUrl} type="audio/mpeg" />
          {' '}
          Your browser does not support the audio tag.
        </audio>
        <label htmlFor="trackType">
          <select {...register('trackType')}>
            <option value={TrackType.AUDIO}>Audio Track</option>
            <option value={TrackType.AUDIO_DESCRIPTION}>Audio Description</option>
          </select>
        </label>
        <button type="button" className="text-red-600" onClick={onDeleteTrack}>Delete</button>
      </div>
    </form>
  )
}
